import { CanonicalLoad } from '@numeo/types-core'

const SIGNATURE_FIELDS: (keyof CanonicalLoad)[] = [
    'pickupCity',
    'pickupStateProv',
    'deliveryCity',
    'deliveryStateProv',
    'weightLbs',
    'brokerMc',
    'equipmentType',
]

export const loadsMatch = (a: CanonicalLoad, b: CanonicalLoad): boolean => {
    if (a.externalId && b.externalId && a.externalId === b.externalId) return true
    return SIGNATURE_FIELDS.every((k) => a[k] === b[k])
}

// only values considered "meaningful" will overwrite
const hasValue = (val: unknown): boolean => {
    if (val === null || val === undefined) return false
    if (typeof val === 'string') return val.trim() !== ''
    if (typeof val === 'number') return !Number.isNaN(val) // allow 0
    if (Array.isArray(val)) return val.length > 0
    if (typeof val === 'object') return Object.keys(val as Record<string, unknown>).length > 0
    return true
}

function setIfHasValue<T, K extends keyof T>(target: T, key: K, value: T[K]) {
    if (hasValue(value)) {
        target[key] = value
    }
}

export function mergeLoadData(incomingLoad: CanonicalLoad, existingLoad: CanonicalLoad): CanonicalLoad {
    const mergedLoad: CanonicalLoad = { ...existingLoad }

    ;(Object.keys(incomingLoad) as Array<keyof CanonicalLoad>).forEach((key) => {
        setIfHasValue(mergedLoad, key, incomingLoad[key])
    })
    return mergedLoad
}

export function nowIso() {
    return new Date().toISOString()
}

export function nowDate() {
    return new Date()
}
